module.exports = __webpack_public_path__ + "img/heart-outline.da7203f1.svg";